import { useEffect, useState } from "react";
import {
  uploadCreditAssessmentData,
  uploadCrifAssessmentData,
  downlaodCreditAssessmentTempalte,
  downlaodCrifAssessmentTempalte,
  getBureauInstitutionList,
  inititateBureauByUserId,
  processBureauUploadedPdfByClientTransactionId,
  getKycVerificationByUserIdNew,
} from "../../ActionCreator";
import Popup from "../../../../../../presentationals/Popup/Popup.component";
import CustomSelect from "../common/CustomSelect";
import { Checkbox, FormControlLabel } from "@mui/material";


function Uploadpopup({
  open,
  onClose,
  allDetail,
  setLoader,
  callAllApis,
  showCredit = true,
  showborrowerOnly = true

}) {
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [crifFile, setCrifFile] = useState(null);
  const [activeTab, setActiveTab] = useState("crif");
  const [creditFile, setCreditFile] = useState(null);
  const [data, setData] = useState({
    institutionId: "",
    userId: "",
  });
  const [institutionList, setInstitutionList] = useState([]);
  const [clientTransactionId, setClientTransactionId] = useState(null);
  const [pdfUploadedRes, setPdfUploadedRes] = useState();
  const [isPdfProtected, setIsPdfProtected] = useState(false);
  const [isPasswordRequiredShow, setIsPasswordRequiredShow] = useState(false);
  const [pdfPassword, setPdfPassword] = useState("");
  const isBureauInitiated = !!clientTransactionId;
  const acceptedFormats = [".csv", ".xlsx", ".xls"];
  const [allusers, setAllUsers] = useState([]);

  // ---------------- POPUP ----------------
  const showPopup = (msg) => {
    setPopup({ show: true, popupStatus: msg });
    setTimeout(() => setPopup({ show: false, popupStatus: "" }), 3000);
  };

  const handleFileChange = (e, type) => {
    console.log("selected", e.target.files[0], type);
    const selected = e.target.files[0];
    if (!selected) return;
    if (type === "crif") {
      if (selected.type !== "application/pdf") {
        setPopup({
          show: true,
          popupStatus: "Only PDF file allowed for CRIF",
        });
        return;
      }

      // optional size limit (recommended)
      if (selected.size > 5 * 1024 * 1024) {
        setPopup({
          show: true,
          popupStatus: "Max file size is 5MB",
        });
        return;
      }

      setCrifFile(selected);
    } else {
      setCreditFile(selected);
    }
    // else setCreditFile(selected);
  };

  const handleUpload1 = () => {
    if (!crifFile) return;

    const formData = new FormData();
    if (crifFile) formData.append("file", crifFile);
    setLoader(true);
    uploadCrifAssessmentData(clientTransactionId, formData, (callback) => {
      setLoader(false);
      if (callback?.success == true) {
        setPdfUploadedRes(callback?.data);
        if (isPdfProtected == false) {
          processBureauUploadedPdfByClientTransactionId(
            clientTransactionId,
            {
              fileId: callback?.data?.fileId || "",
              password: "",
              institutionId: "10991",
              consolidatedBureau: false,
            },
            (res) => {
              if (res?.success) {
                setPopup({
                  show: true,
                  popupStatus: "file Processed Successfully",
                });
              } else {
                setPopup({
                  show: true,
                  popupStatus:
                    res?.message || res?.data?.message ||
                    "Failed to process uploaded file, try uploading again",
                });
              }
            },
            (err) => {
              showPopup(error?.response?.data?.message || res?.message || "Failed to process uploaded file, try uploading again");

              console.log("Error to process Bureau uploaded pdf", err);
            },
          );
        }
        callAllApis();
        setPopup({ show: true, popupStatus: "file Uploaded Successfully" });
      }
      removePopup();
    });
  };
  const handleUpload2 = () => {
    if (!creditFile) return;

    const formData = new FormData();
    if (creditFile) formData.append("file", creditFile);
    setLoader(true);
    uploadCreditAssessmentData(allDetail?.userId, formData, (callback) => {
      setLoader(false);
      if (callback?.success === true) {
        console.log("credit upload res", callback);
        setPopup({ show: true, popupStatus: "file Uploaded Successfully" });
        callAllApis();
      }
      removePopup();
    });
  };

  const handleDownloadTemplate = (type) => {
    if (type == "credit") {
      setLoader(true);
      downlaodCreditAssessmentTempalte((callback) => {
        setLoader(false);
      });
    }
    if (type == "crif") {
      setLoader(true);
      downlaodCrifAssessmentTempalte((callback) => {
        setLoader(false);
      });
    }
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: "" });
  };
  const removePopup = () => {
    setTimeout(() => {
      closePopup();
    }, 5000);
  };

  const canUploadcrif = crifFile;
  const canUploadcredit = creditFile;

  useEffect(() => {
    if (!open) return;
    getBureauInstitutionList((res) => {
      if (res?.success) {
        setInstitutionList(res?.data?.institutions?.institution || []);
      }
    });
    getAllUsers();
  }, [open]);

  const handleInititateBureau = () => {
    if (!data?.userId) {
      return showPopup("Select user first");
    }

    if (!data?.institutionId) {
      return showPopup("Select bank first");
    }

    setLoader(true);
    inititateBureauByUserId(
      data?.userId,
      {
        loanAmount: 100000,
        loanDuration: 24,
        loanType: "Home",
        yearMonthFrom: "2025-01",
        yearMonthTo: "2025-12",
        institutionId: data.institutionId,
      },
      (res) => {
        setLoader(false);

        if (res?.success) {
          const id = res?.data?.clientTransactionId;
          setClientTransactionId(id);
          showPopup("Bureau Initiated Successfully");
        } else {
          showPopup(
            res?.message || res?.data?.message || "Failed to initiate bureau",
          );
        }
      },
      (err) => {
        setLoader(false);
        console.log("Error to initiate bureau", err);
        showPopup(error?.response?.data?.message || res?.response?.message || "Failed to initiate bureau");

      }
    );
  };

  const handleProcessBureauUploadedPdf = () => {
    if (!pdfUploadedRes?.fileId && !pdfPassword) {
      return showPopup("Please Enter PDF Password and click Process PDF");
    }
    processBureauUploadedPdfByClientTransactionId(
      clientTransactionId,
      {
        fileId: pdfUploadedRes?.fileId || "",
        password: pdfPassword,
        institutionId: "10991",
        consolidatedBureau: false,
      },
      (res) => {
        if (res?.success) {
          setPopup({
            show: true,
            popupStatus: "file Processed Successfully",
          });
        } else {
          setPopup({
            show: true,
            popupStatus:
              res?.message ||
              res?.data?.message ||
              "Failed to process uploaded file, try uploading again",
          });
        }
      },
      (err) => {
        console.log("Errpr to process Bureau uploaded pdf", err);
        showPopup(error?.response?.data?.message || res?.message || "Process failed");

      },
      removePopup(),
    );
  };
  const handleChange = (event) => {
    setIsPdfProtected(event.target.checked);
  };

  const getAllUsers = () => {
    getKycVerificationByUserIdNew(
      allDetail?.userId,
      (res) => {
        console.log("KYC res", res);
        const usersData = res?.data || {};

        const allUsers = Object.entries(usersData)
          .filter(([_, users]) => Array.isArray(users))
          .flatMap(([userType, users]) =>
            users.map((user) => ({
              ...user,
              userType,
            })),
          );
        console.log("dffrhhbr", allUsers);

        setAllUsers(allUsers);
      },
      (err) => {
        console.log("Errpr to get KYC", err);
      },
    );
  };

  return (
    <>
      {popup?.show ? (
        <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
      ) : (
        ""
      )}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              width: "480px",
              padding: "24px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              position: "relative",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
          >
            {/* Close */}
            <span
              onClick={onClose}
              style={{
                position: "absolute",
                top: "12px",
                right: "16px",
                cursor: "pointer",
                fontSize: "20px",
                color: "#6b7280",
                lineHeight: 1,
              }}
            >
              ✕
            </span>

            <h3
              style={{
                margin: "0 0 20px 0",
                fontSize: "16px",
                fontWeight: 700,
                color: "#111827",
              }}
            >
              Upload Files
            </h3>

            {showCredit && (
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginBottom: "16px",
                }}
              >
                <button
                  onClick={() => setActiveTab("crif")}
                  style={getTabStyle(activeTab === "crif")}
                >
                  CRIF
                </button>

                <button
                  onClick={() => setActiveTab("credit")}
                  style={getTabStyle(activeTab === "credit")}
                >
                  Credit
                </button>
              </div>
            )}

            {/* Two Upload Zones Side by Side */}
            <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
              {activeTab === "crif" ? (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {/* <CustomSelect
                    value={data.userId}
                    placeholder="Select User"
                    label="Select User"
                    onChange={(e) =>
                      setData((pre) => ({ ...pre, userId: e.target.value }))
                    }
                    options={
                      allusers?.length > 0
                        ? allusers?.map((user) => ({
                            label:
                              user?.userType === "BORROWER"
                                ? `${user?.businessName ?? "Unknown Business"} - ${user?.userType}`
                                : `${user?.fullName ?? "Unknown User"} - ${user?.userType}`,
                            value: user?.userId,
                          }))
                        : [
                            {
                              label: "No users found",
                              value: "",
                            },
                          ]
                    }
                  /> */}

                  <CustomSelect
                    value={data.userId}
                    placeholder="Select User"
                    label="Select User"
                    onChange={(e) =>
                      setData((pre) => ({ ...pre, userId: e.target.value }))
                    }
                    options={
                      allusers?.length > 0
                        ? allusers
                          ?.filter(
                            (user) =>
                              !showborrowerOnly || user?.userType === "BORROWER"
                          )
                          ?.map((user) => ({
                            label:
                              user?.userType === "BORROWER"
                                ? `${user?.businessName ?? "Unknown Business"} - ${user?.userType}`
                                : `${user?.fullName ?? "Unknown User"} - ${user?.userType}`,
                            value: user?.userId,
                          }))
                        : [
                          {
                            label: "No users found",
                            value: "",
                          },
                        ]
                    }
                  />

                  <CustomSelect
                    value={data.institutionId}
                    placeholder="Select Bureau"
                    label="Select Bureau"
                    onChange={(e) =>
                      setData((pre) => ({
                        ...pre,
                        institutionId: e.target.value,
                      }))
                    }
                    options={institutionList.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                  />
                  <button
                    onClick={handleInititateBureau}
                    // disabled={isBureauInitiated}
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: "#2563eb",
                      color: "#fff",
                      border: "none",
                      borderRadius: "7px",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "16px",
                      transition: "background-color 0.2s",
                    }}
                  >
                    {"Initiate Bureau"}
                  </button>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#374151",
                    }}
                  >
                    CRIF File
                  </p>
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        border: `2px dashed ${crifFile ? "#3b82f6" : "#d1d5db"}`,
                        borderRadius: "8px",
                        padding: "20px 10px",
                        cursor: "pointer",
                        textAlign: "center",
                        backgroundColor: crifFile ? "#eff6ff" : "#f9fafb",
                        transition: "all 0.2s ease",
                        minHeight: "90px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        position: "relative",
                        zIndex: "1",
                      }}
                    >
                      {/* Upload Icon */}
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke={crifFile ? "#3b82f6" : "#9ca3af"}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="16 16 12 12 8 16" />
                        <line x1="12" y1="12" x2="12" y2="21" />
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                      </svg>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: crifFile ? "#3b82f6" : "#6b7280",
                          wordBreak: "break-all",
                          padding: "0 4px",
                        }}
                      >
                        {crifFile ? crifFile?.name : "Click to upload"}
                      </p>
                    </div>
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => handleFileChange(e, "crif")}
                      style={{
                        opacity: "0",
                        width: "100%",
                        position: "absolute",
                        inset: "0",
                        zIndex: "2",
                        backgroundColor: isBureauInitiated
                          ? "#2563eb"
                          : "#d1d5db",
                        cursor: isBureauInitiated ? "pointer" : "not-allowed",
                      }}
                      disabled={!isBureauInitiated}
                    />
                  </div>

                  <button
                    onClick={handleUpload1}
                    disabled={!canUploadcrif}
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: canUploadcrif ? "#2563eb" : "#d1d5db",
                      color: "#fff",
                      border: "none",
                      borderRadius: "7px",
                      cursor: canUploadcrif ? "pointer" : "not-allowed",
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "16px",
                      transition: "background-color 0.2s",
                    }}
                  >
                    Upload File{crifFile && creditFile ? "s" : ""}
                  </button>
                  <div className="mb-0">
                    <FormControlLabel
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: 500,
                        },
                      }}
                      control={
                        <Checkbox
                          checked={isPdfProtected}
                          onChange={handleChange}
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 22,
                            },
                          }}
                        />
                      }
                      label="Is PDF password protected?"
                    />
                  </div>
                  <div>
                    {isPdfProtected && (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "flex-end",
                        }}
                      >
                        <div>
                          <label htmlFor="pdfPassword">PDF Password:</label>
                          <input
                            type="password"
                            value={pdfPassword}
                            onChange={(e) => setPdfPassword(e.target.value)}
                            placeholder="Enter Password"
                            style={{
                              width: "100%",
                              border: "1px solid black",
                              padding: "7px 5px",
                              borderRadius: "7px",
                              minWidth: "230px",
                            }}
                          />
                        </div>
                        <div>
                          <button
                            style={{
                              width: "100%",
                              padding: "9px 10px",
                              backgroundColor:
                                pdfUploadedRes?.fileId && pdfPassword
                                  ? "#2563eb"
                                  : "#d1d5db",
                              color: "#fff",
                              border: "none",
                              borderRadius: "7px",
                              cursor:
                                pdfUploadedRes?.fileId && pdfPassword
                                  ? "pointer"
                                  : "not-allowed",
                              fontWeight: 600,
                              fontSize: "14px",
                              transition: "background-color 0.2s",
                            }}
                            disabled={!pdfUploadedRes?.fileId || !pdfPassword}
                            onClick={handleProcessBureauUploadedPdf}
                          >
                            Process PDF
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#374151",
                    }}
                  >
                    Credit File
                  </p>
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        border: `2px dashed ${creditFile ? "#3b82f6" : "#d1d5db"}`,
                        borderRadius: "8px",
                        padding: "20px 10px",
                        cursor: "pointer",
                        textAlign: "center",
                        backgroundColor: creditFile ? "#eff6ff" : "#f9fafb",
                        transition: "all 0.2s ease",
                        minHeight: "90px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        position: "relative",
                        zIndex: "1",
                      }}
                    >
                      {/* Upload Icon */}
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke={creditFile ? "#3b82f6" : "#9ca3af"}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="16 16 12 12 8 16" />
                        <line x1="12" y1="12" x2="12" y2="21" />
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                      </svg>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: creditFile ? "#3b82f6" : "#6b7280",
                          wordBreak: "break-all",
                          padding: "0 4px",
                        }}
                      >
                        {creditFile ? creditFile?.name : "Click to upload"}
                      </p>
                    </div>
                    <input
                      type="file"
                      accept={acceptedFormats.join(",")}
                      onChange={(e) => handleFileChange(e, "credit")}
                      style={{
                        opacity: "0",
                        width: "100%",
                        position: "absolute",
                        inset: "0",
                        zIndex: "2",
                      }}
                    />
                  </div>
                  <button
                    onClick={handleUpload2}
                    disabled={!canUploadcredit}
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: canUploadcredit ? "#2563eb" : "#d1d5db",
                      color: "#fff",
                      border: "none",
                      borderRadius: "7px",
                      cursor: canUploadcredit ? "pointer" : "not-allowed",
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "16px",
                      transition: "background-color 0.2s",
                    }}
                  >
                    Upload File{crifFile && creditFile ? "s" : ""}
                  </button>
                </div>
              )}
            </div>

            {/* Divider */}
            <div
              style={{
                borderTop: "1px solid #e5e7eb",
                marginBottom: "14px",
              }}
            />

            {activeTab === "credit" && (
              <>
                <p
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Download Templates
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    onClick={() => handleDownloadTemplate("credit")}
                    style={{
                      flex: 1,
                      padding: "8px 10px",
                      backgroundColor: "#eff6ff",
                      color: "#2563eb",
                      border: "1px solid #bfdbfe",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    <svg
                      style={{ width: "auto" }}
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Credit Template
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        // </div>
      )}
    </>
  );
}

export default Uploadpopup;

const baseTabStyle = {
  flex: 1,
  padding: "8px 10px",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "13px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  border: "1px solid #bfdbfe",
  transition: "all 0.2s ease",
};

const getTabStyle = (isActive) => ({
  ...baseTabStyle,
  backgroundColor: isActive ? "#2563eb" : "#eff6ff",
  color: isActive ? "#fff" : "#2563eb",
  boxShadow: isActive ? "0 2px 6px rgba(37, 99, 235, 0.3)" : "none",
});
